import {Injectable} from '@angular/core';
import {CommonConfiguratorUtilsService} from '@spartacus/product-configurator/common';
import {OrderEntry} from '@spartacus/cart/base/root/models/cart.model';

@Injectable({
  providedIn: 'root',
})
export class OrderItemService {
  public firstOrderEntries: string[] = [];
  protected expandedOrderItems: Map<string, boolean> = new Map<string, boolean>();

  constructor(private commonConfigUtilsService: CommonConfiguratorUtilsService) {
  }

  /**
   * States are kept in this service to make sure that
   * an order entry doesn't collapse the view is updated.
   * This happens when the cart is reloaded by a cart entry change.
   *
   * @param entry OrderEntry to keep the collapsed state of.
   * @param isCollapsed Collapsed state value.
   */
  setOrderItemCollapsedState(entry: OrderEntry, isCollapsed: boolean): void {
    this.expandedOrderItems.set(entry.product.supplierAlternativeAID, isCollapsed);
  }

  getOrderItemCollapsedState(entry: OrderEntry): boolean {
    return this.expandedOrderItems.get(entry.product.supplierAlternativeAID);
  }

  clearOrderItemCollapsedState(): void {
    this.expandedOrderItems.clear();
  }

  getEntityKey(entry: OrderEntry): string {
    const entryNumber = entry?.entryNumber;
    if (entryNumber === undefined) {
      throw new Error('No entryNumber present in entry');
    }

    return entry.orderCode
      ? this.commonConfigUtilsService.getComposedOwnerId(
        entry.orderCode,
        entryNumber
      )
      : entryNumber.toString();
  }
}
